import React, { useContext } from "react";
import {
    Table,
    EllipsisDropdown,
    ControlledPopup,
    Icon,
    HoverList,
} from "dyl-components";
import { DropdownItem, Dropdown, Checkbox, Header,Popup } from "semantic-ui-react";
import { BulkActionsContext } from "shared/context/BulkActionsProvider";
import { PhoneUtil } from "utils";
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';

const Row = ({ group, onEditRingGroupCallQueue, onRemove }) => {
    const [selectedItems, setSelectedItems] = useContext(BulkActionsContext);

    const isSelected = (extension_id) => {
        return selectedItems.includes(extension_id);
    };

    const onToggleExtension = (extension_id) => {
        const newSelectedExtensions = isSelected(extension_id)
            ? selectedItems.filter((id) => extension_id !== id)
            : [...selectedItems, extension_id];
        setSelectedItems(newSelectedExtensions);
    };

    const getMembersString = (arr, param, subParam) => {
        const namesArr = [];
        arr?.forEach((item) => {
            let name = `Ext. ${item[param]}`;
            if (subParam && item[subParam]) {
                name = `${name}  ${item[subParam]?.first_name} ${item[subParam]?.last_name} `;
            }
            namesArr.push(name);
        });
        return namesArr;
    };

    const getIconName = (type) => {
        switch (type) {
            case "ring_group":
                return "fa-solid fa-phone-volume";
            case "call_queue":
                return "fa-solid fa-user-clock";
            default:
                return "";
        }
    };

    const getTextFromKey = (key) => {
        const extension = PhoneUtil.DESTINATION_TYPES.find(
            (ext) => ext.key === key
        );
        return extension ? extension.text : null;
    };

    return (
        <Table.Row>
            <Table.Cell>
                <Checkbox
                    checked={isSelected(group.id)}
                    onChange={() => {
                        onToggleExtension(group.id);
                    }}
                    disabled
                />
            </Table.Cell>
            <Table.Cell>{group.label}</Table.Cell>
            <Table.Cell>
                <Icon className={getIconName(group.group_type)} />
                {getTextFromKey(group.group_type)}
            </Table.Cell>
            <Table.Cell>{group?.alias && `${group?.alias}`}</Table.Cell>
            <Table.Cell>{group.view ? "On" : "Off"}</Table.Cell>
            <Table.Cell className="receive-calls-container">
                <HoverList
                    list={
                        getMembersString(
                            group?.members?.data,
                            "member",
                            "user"
                        ) || []
                    }
                    scroll={true}
                />
            </Table.Cell>
            <Table.Cell>
                <EllipsisDropdown>
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_EDIT}>
                        <DropdownItem
                            style={{ cursor: "pointer" }}
                            text="Edit"
                            icon="fas fa-edit"
                            onClick={() => onEditRingGroupCallQueue(group, "edit")}
                        />
                    </RestrictedView>
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_ADD}>
                        <DropdownItem
                            style={{ cursor: "pointer" }}
                            text="Duplicate"
                            icon="fas fa-copy"
                            onClick={() =>
                                onEditRingGroupCallQueue(group, "duplicate")
                            }
                        />
                    </RestrictedView>
                    <RestrictedView type='controlledPopupDisabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_DELETE}>
                        <ControlledPopup
                            header={
                                <Header as='h4' textAlign='center'>
                                    Are you sure?
                                    <Header.Subheader style={{ marginTop: 5 }}>
                                    You cannot undo delete actions.
                                    </Header.Subheader>
                                </Header>
                            }
                            trigger={
                                group.in_use ? (
                                    <Popup
                                        content={`${getTextFromKey(group.group_type)} in use`}
                                        position="right center"
                                        inverted
                                        on={'hover'}
                                        trigger={
                                            <Dropdown.Item 
                                                className={`ringGroup-callQueues-${
                                                    group.in_use ? "disable" : ""
                                                }`}
                                                text="Delete"
                                                icon="fa-solid fa-trash"
                                            />
                                        }
                                    />
                                ) : (
                                    <Dropdown.Item
                                        text="Delete"
                                        icon="fa-solid fa-trash"
                                    />
                                )
                            }
                            onConfirm={() => onRemove(group.id, group.group_type)}
                            inverted
                        />
                    </RestrictedView>
                </EllipsisDropdown>
            </Table.Cell>
        </Table.Row>
    );
};

export default Row;
